import CargoCompanyAddressFetchInitDataRequest from "../../../../api/raily/cargo-company/address/fetch-init-data/cargo-company-address-fetch-init-data.request";
import CargoCompanyAddressFetchInitDataParams from "./cargo-company-address-fetch-init-data-params";

const create = (
  params: CargoCompanyAddressFetchInitDataParams,
): CargoCompanyAddressFetchInitDataRequest => {
  return {
    addressUuid: params.addressUuid,
    cargoCompanyUuid: params.cargoCompanyUuid,
  };
};

const cargoCompanyAddressFetchInitDataParamsFactory = {
  create,
};

export default cargoCompanyAddressFetchInitDataParamsFactory;
